import { Injectable } from '@angular/core';
import {BaseRestService} from '../../shared/services/base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../../shared/models/send-back-result';
import {ArrayResponse, serializeQueryString} from '..';
import {ContractLink, ContractLinkSummaries} from '../models/contract-link';

@Injectable({
  providedIn: 'root'
})
export class ReturnPlayerService  extends BaseRestService  {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }
  protected get className(): string { return 'ReturnPlayerService'; }
  protected get isAnonymous(): boolean { return false; }



  // tslint:disable-next-line:no-any
  loadSummary(data: Object): Observable<SendBackResult<ArrayResponse<any>>> {
    // tslint:disable-next-line:no-any
    return this.post<ArrayResponse<any>>(`/Subscription/SummariesWithPlayer`, data);
  }

  // tslint:disable-next-line:no-any
  update(data: any , clientUuid: string): Observable<SendBackResult<boolean>> {
    return this.post<boolean>(`/clients/${clientUuid}/patch/subscriptions`, data);
  }
}
